<template>
    <b-modal modal-class="apprentice-default-modal roadmap-steps-modal"
             id="roadmap-steps-modal"
             size="lg"
             :title="title"
             hide-footer
             v-model="modal"
             @shown="onShown"
             @hide="shown = false"
             :no-enforce-focus="true">

        <div class="tabs steps-tabs apprentice-tab-with-tabs-control">
            <div class="previous-tab">
                <b-button class="btn-chevron-left btn-previous-step"
                          variant="primary-icon-only"
                          :disabled="isBeginning"
                          @click.prevent="previousStep">
                </b-button>
            </div>

            <design-2021-apprentice-swiper-component :slides="stepsIn.length"
                                                     :breakpoints="breakpoints"
                                                     :slides-per-view="7"
                                                     :space-between="15"
                                                     :center-insufficient-slides="true"
                                                     :slide-to-clicked-slide="true"
                                                     :centered-slides="false"
                                                     :centered-slides-bounds="true"
                                                     :enable-navigation="true"
                                                     ref="roadmapDetailSwiper">

                <template #[getSlotName(index)] v-for="(step, index) in stepsIn">
                    <a class="nav-link"
                       :class="[step.id === selectedStep.id ? 'active' : null, setStatuscolor(step)]"
                       @click="updateSelectedStep(step.id)"
                       href="#">
                        <div class="order">
                            Stap {{ step.order }}
                        </div>
                    </a>
                </template>

            </design-2021-apprentice-swiper-component>

            <design-2021-roadmap-step-tab-component
                :step-in="selectedStep"
                :project-id-in="projectIdIn"
                @updateTitleFinished="updateTitleStatus"
                @updateTitleStatus="updateTitleStatus"
                @updateComments="updateComments">
            </design-2021-roadmap-step-tab-component>
        </div>

        <div class="next-tab">
            <b-button class="btn-chevron-right btn-next-step"
                      variant="primary-icon-only"
                      :disabled="isEnd"
                      @click.prevent="nextStep">
            </b-button>
        </div>
    </b-modal>
</template>

<script>

export default {
    name: "design-2021-roadmap-step-detail-modal-component",
    props: {
        title: String,
        stepsIn: Array,
        tabIndex: Number,
        projectIdIn: Number,
    },
    data() {
        return {
            shown: false,
            selectedIndex: this.tabIndex,
            breakpoints: {
                1200: {
                    slidesPerView: 7,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: 7,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 15
                },
                576: {
                    slidesPerView: 4,
                    spaceBetween: 15
                },
                320: {
                    slidesPerView: 3,
                    spaceBetween: 15
                }
            },
            modal: false,
            roadmapDetailSwiper: null,
        }
    },

    computed: {
        selectedStep() {
            return this.stepsIn.find((step, index) => index === this.selectedIndex);
        },

        isBeginning(){
            if(!this.roadmapDetailSwiper){
                return false;
            }

            return this.roadmapDetailSwiper.isBeginning;
        },

        isEnd() {
            if(!this.roadmapDetailSwiper){
                return false;
            }

            return this.roadmapDetailSwiper.isEnd;
        },
    },

    watch: {
        tabIndex: function (value) {
            this.selectedIndex = value;
        }
    },

    methods: {
        getSlotName(index){
            return `slide-${index}`;
        },

        show() {
            this.modal = true;
            this.$nextTick(() =>{
                this.roadmapDetailSwiper =  this.$refs.roadmapDetailSwiper.$refs.apprenticeSwiper.swiper;
                this.roadmapDetailSwiper.slideTo(this.selectedIndex);
            });
        },

        onShown() {
            this.shown = true
        },

        updateTitleStatus(data) {
            const steps = this.stepsIn.map((step) => {
                if (step.id !== data.id) {
                    return step;
                }

                let updatedStep = {...step}

                if (updatedStep.status.length === 1) {
                    updatedStep.status[0].status = data.status;
                    updatedStep.status[0].finished = data.finished;
                } else {
                    updatedStep.status = [];
                    updatedStep.status[0] = {};
                    updatedStep.status[0].status = data.status;
                    updatedStep.status[0].finished = data.finished;
                }

                updatedStep.updates = data.updates;
                return updatedStep;
            });

            this.$emit('update-steps', steps);
        },

        updateComments(data) {
            const steps = this.stepsIn.map((step) => {
                if (step.id !== data.id) {
                    return step;
                }
                let updatedStep = {...step}
                updatedStep.comments = data.comments;
                return updatedStep;
            });

            this.$emit('update-steps', steps);
        },

        updateSelectedStep(stepId) {
            if(this.selectedStep.id !== stepId){
                this.selectedIndex = this.stepsIn.map(step => step.id).indexOf(stepId);
                this.$emit('selected-step', this.selectedIndex)
            }
        },

        nextStep() {
            this.roadmapDetailSwiper.slideNext();
        },

        previousStep() {
            this.roadmapDetailSwiper.slidePrev();
        },

        setStatuscolor (step) {
            if (step.status.length > 0) {
                if (step.status[0].finished) {
                    if (step.status[0].status === 0) {
                        //'Afgerond / ingeleverd';
                        return 'warning';
                    } else if (step.status[0].status === 1) {
                        //'Goedgekeurd';
                        return 'success';
                    }
                } else if (step.status[0].status === 2)  {
                    //'Opnieuw';
                    return 'danger';
                } else {
                    //'Open';
                    return 'primary';
                }
            } else {
                //'Open';
                return 'primary';
            }
        }
    },
}
</script>

<style scoped lang="scss">
    ::v-deep .roadmap-steps-modal {
        .modal-header,
        .modal-body {
            background-color: $secondary-background-color;
        }
    }

    .roadmap-steps-modal {
        .previous-tab,
        .next-tab {
            position: absolute;
            top: 31px;
            z-index: 12;

            .btn-next-step,
            .btn-previous-step {
                &:disabled {
                    background-color: transparent;
                    color: $primary;
                }

                &:before {
                    margin-right: 0;
                }

                &:hover {
                    font-weight: $font-weight-bold;
                }
            }
        }

        .previous-tab {
            left: 6px;
        }

        .next-tab {
            right: 6px;
        }
    }

    .steps-tabs ::v-deep {
        .swiper-container {
            margin: 0 map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing,'ten');

            .roadmap-step-slide {
                .nav-link {
                    position: relative;

                    &:hover,
                    &.active {
                        border: none;
                        color: $primary;
                        font-weight: $font-weight-bold;

                        .order {
                            &:after {
                                background-color: $primary;
                                left: calc(50% - 10.5px);
                                opacity: 1;
                            }
                        }
                    }

                    &.success,
                    &.active.succes {
                        &,
                        &:hover{
                            color: $success;
                        }

                        .order {
                            &:after {
                                background-color: $success;
                            }
                        }
                    }

                    &.danger,
                    &.active.danger {
                        &,
                        &:hover {
                            color: $danger;
                        }

                        .order {
                            &:after {
                                background-color: $danger;
                            }
                        }
                    }

                    &.warning,
                    &.active.warning {
                        &,
                        &:hover {
                            color: $warning;
                        }

                        .order {
                            &:after {
                                background-color: $warning;
                            }
                        }
                    }

                    .order {
                        &:after {
                            display: block;
                            content: "";
                            width: 21px;
                            height: 5px;
                            background-color: transparent;
                            margin-top: map-get($grid-gutter-spacing, 'fifteen');
                            position: relative;
                            left: -21px;
                            opacity: 0;
                            transition: all 0.3s ease-in-out;
                        }
                    }
                }

                .order {
                    text-align: center;
                }
            }

            .swiper-button-prev,
            .swiper-button-next {
                display: none;
            }
        }


    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
        .steps-tabs  ::v-deep {

        }
    }

</style>
